import { createContext, useState } from 'react';
import { CreateTree } from '../Helper/Utility';
import { GetGarages } from '../Helper/MyCars';
import Config from '../appConfig';

export const ConfigContext = createContext();

export const ConfigProvider = ({ children }) => {
  const [apiURL, setAPIURL] = useState('https://api.carz7.com');
  const [apiB2BURL] = useState('https://b2bapi.ghayar.com');
  const [gdcURL, setGDCURL] = useState('https://dcapi.carz7.com');

  const [OEImagesURL] = useState('https://ghayar.ae/img.php');
  const [OEDetailsImagesURL] = useState('https://ghayar.ae/imgs.php');

  const [rewards_points] = useState(localStorage.getItem("business_reward_point_x"));
  const [min_purchase_amount] = useState(localStorage.getItem("min_purchase"));

  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [showPopupScreen, setShowPopupScreen] = useState(localStorage.getItem("popup_seen"));

  const closePopup = () => {
    localStorage.setItem("popup_seen", "yes");
    setShowLoginPopup(false);
  }

  const HandleLogout = () => {
    localStorage.setItem('token', '');
    localStorage.setItem('business_user_id', '');
    localStorage.setItem('business_id', '');
    localStorage.setItem('user_name', '');
    localStorage.setItem('business_name', '');
    localStorage.setItem('business_contact_number', '');

    localStorage.removeItem("marqueeRows");
    localStorage.removeItem("business_delivery_days");
    localStorage.removeItem("popup_seen");
    localStorage.removeItem("currency");
    localStorage.removeItem("business_reward_point_x");

    window.location = '/Login';
  }


  const [popular_models, setPopularModels] = useState([]);

  const [token, setToken] = useState(localStorage.getItem('token'));
  const [business_id] = useState(localStorage.getItem("business_id"));
  const [business_user_id] = useState(localStorage.getItem("business_user_id"));
  const [business_ledger_id] = useState(localStorage.getItem("business_ledger_id"));

  const [business_type] = useState(Number(localStorage.getItem("business_type")));
  const [business_delivery_days] = useState(Number(localStorage.getItem("business_delivery_days")));

  const [isCartUpdate, setIsCartUpdate] = useState(false);
  const [isFavUpdate, setIsFavUpdate] = useState(false);

  const [modalZIndex, setModalZIndex] = useState(true);

  const [makeTip, setMakeTip] = useState(true);
  const [searchInputTip, setSearchInputTip] = useState(true);

  const handleCloseSearchInputTip = () => {
    setSearchInputTip(false);
  };

  const handleCancelZIndex = () => {
    setModalZIndex(true);
  };

  const handleCloseTip = () => {
    setMakeTip(false);
  };


  const [apiHeaderJson] = useState({
    "Content-Type": "application/json",
    token: `${token}`,
    "businessid": business_id,
    businessuserid: business_user_id,
  });

  const [apiHeaderFile] = useState({
    "Content-Type": "multipart/form-data",
    token: `${token}`,
    "businessid": business_id,
    businessuserid: business_user_id,
  });

  const [PCID, setStatePCID] = useState(localStorage.getItem('pc_id'));
  const [MSID, setStateMSID] = useState(localStorage.getItem('ms_id'));

  const setContextPCID = (pc_id) => {
    setStatePCID(pc_id)
  }
  const setContextMSID = (ms_id) => {
    setStateMSID(ms_id)
  }

  const [isUserInternational, setIsUserInternational] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [categories, setStateCategories] = useState(() => {
    const storedCategories = localStorage.getItem('categories');
    return storedCategories && storedCategories !== 'undefined'
      ? JSON.parse(storedCategories)
      : [];
  });
  const [treeCategories, setStateTreeCategories] = useState([]);

  const [cars, setStateCars] = useState([]);
  const [allCars, setStateallCars] = useState([]);
  const [makes, setStateMakes] = useState([]);
  const [years, setStateYears] = useState([]);
  const [models, setStateModels] = useState([]);
  const [engines, setStateEngines] = useState([]);
  const [CarStatus, setStateCarStatus] = useState(false);
  const [CartStatus, setStateCartStatus] = useState(false);
  const [CarList, setStateCarList] = useState([]);
  const [CartList, setStateCartList] = useState([]);
  const [CartItemsQty, setStateCartItemsQty] = useState(0);

  const [FavItemsQty, setStateFavItemsQty] = useState(0);

  const [FavItems, setStateFavItems] = useState([]);
  const [CartAmount, setStateCartAmount] = useState(0);
  const [CartProcessStatus, setCartProcessStatus] = useState(false);
  const [SideCartStatus, setStateSideCartStatus] = useState(false);


  const [lang, setStateLang] = useState(localStorage.getItem('selectedLanguage') || 'en');

  const [sideBarStatus, setStateSideBarStatus] = useState(false);
  const [MyGarageCars, setMyGarageCars] = useState(GetGarages());
  const [TillYear] = useState(2024);
  const [isCartDropdownOpen, setIsCartDropdownOpenState] = useState(false);
  const [paymentMethod, setPaymentMethodState] = useState(localStorage.getItem('paymentMethod'));



  const vat_amount = 5;



  const [marqueeRows, setMarqueeRows] = useState(() => {
    const data = localStorage.getItem("marqueeRows");
    return data ? JSON.parse(data) : [];
  });

  const setPaymentMethod = (value) => {
    setPaymentMethodState(value);
    localStorage.setItem('paymentMethod', value);
  }

  const removePaymentMethod = () => {
    setPaymentMethodState(null);
    localStorage.removeItem("paymentMethod");
  };

  const setIsCartDropdownOpen = (status) => {
    setIsCartDropdownOpenState(status);
  }
  const setMarqueeData = (data) => {
    localStorage.setItem('marqueeRows', JSON.stringify(data));
    setMarqueeRows(data);
  }

  const [resizeState, setResizeState] = useState({
    // isMobile: window.innerWidth <= 768,
    isMobile: true,
    loading: false,
    error: null,
  });

  const setSideBarStatus = (status) => {
    setStateSideBarStatus(status);
  }

  const saveCarInformation = (brand, year, model, engine, fuel_type) => {
    localStorage.setItem('selected_car_make', brand);
    localStorage.setItem('selected_car_year', year);
    localStorage.setItem('selected_car_model', model);
    localStorage.setItem('selected_car_engine', engine);
    localStorage.setItem('selected_car_fuel_type', fuel_type);
  }

  const setFavItemsQty = (qty) => {
    setStateFavItemsQty(qty ?? 0);
  }

  const setFavItems = (items) => {
    setStateFavItems(items);
  }

  const setCartItemsQty = () => {
    try {
      if (localStorage.getItem('carts') !== null && localStorage.getItem('carts') !== '') {
        var carts = JSON.parse(localStorage.getItem('carts'));
        setStateCartItemsQty(carts.length);
      } else {
        setStateCartItemsQty(0);
        setStateCartAmount("00.0");
      }
    } catch (err) {
      setStateCartItemsQty(0);
      setStateCartAmount("00.0");
    }
  }

  const ClearCart = () => {
    localStorage.removeItem('carts');
    setStateCartItemsQty(0);
    setStateCartAmount("00.0");
  }

  const setCategories = async (data) => {
    localStorage.setItem('categories', JSON.stringify(data));
    setStateCategories(data);
    var treecats = "";
    treecats = await CreateTree(data.filter((item) => item.TotalPrices > 0), PCID);
    treecats = treecats.filter(item => !(!item.children || item.children.length === 0));
    setStateTreeCategories(treecats);
  }

  const setCars = (data) => { setStateCars(data); setStateallCars(data); }

  const setLang = (data) => {
    localStorage.setItem('selectedLanguage', data);
    setStateLang(data);
  }

  const [currency, setStateCurrency] = useState(() => {
    const savedCurrency = localStorage.getItem("currency");

    if (savedCurrency) {
      return savedCurrency;
    }

    localStorage.setItem("currency", Config.currency);
    return Config.currency;
  });

  const setCurrency = (data) => {
    localStorage.setItem("currency", data);
    setStateCurrency(data);
  };

  const setMakes = (data) => { setStateMakes(data); }
  const setYears = (data) => { setStateYears(data); }
  const setModels = (data) => { setStateModels(data); }
  const setEngines = (data) => { setStateEngines(data); }

  const ChangeCarStatus = (data) => {
    setStateCarStatus(data);
  }
  const ChangeCartStatus = (data) => {
    setStateCartStatus(data);
  }

  const UpdateCarList = (data) => { setStateCarList(data); }

  const UpdateCartList = (data) => {
    setStateCartList(data);
  }




  const ChangeCartProcessStatus = (data) => {
    setCartProcessStatus(data);
  }
  const ChangeSideCartStatus = (data) => {
    setStateSideCartStatus(data);
  }
  const setLoginStatus = (data) => {
    setIsLoggedIn(data);

  }

  const setWindowResize = (data) => {
    setResizeState(data);
  };

  var vals = {
    apiURL, setAPIURL,
    token, setToken,
    isLoggedIn, setIsLoggedIn,
    categories, setCategories,
    cars, setCars, allCars,
    makes, setMakes, years, setYears, models, setModels, engines, setEngines,
    CarStatus, ChangeCarStatus,
    CartStatus, ChangeCartStatus,
    CarList, UpdateCarList,
    CartList, UpdateCartList,
    CartProcessStatus, ChangeCartProcessStatus,
    SideCartStatus, ChangeSideCartStatus,
    setLoginStatus,
    resizeState, setWindowResize,
    lang, setLang,
    currency, setCurrency,
    gdcURL, setGDCURL,
    CartItemsQty, setCartItemsQty,
    PCID, setContextPCID,
    MSID, setContextMSID,
    sideBarStatus, setSideBarStatus,
    treeCategories,
    CartAmount,
    ClearCart,
    isUserInternational, setIsUserInternational,
    MyGarageCars, setMyGarageCars,
    saveCarInformation,
    TillYear,
    paymentMethod, setPaymentMethod,
    isCartDropdownOpen, setIsCartDropdownOpen,
    apiB2BURL,
    marqueeRows, setMarqueeData,
    FavItemsQty, setFavItemsQty,
    FavItems, setFavItems,

    business_user_id,
    business_id,
    apiHeaderJson,
    apiHeaderFile,
    business_type,
    setIsCartUpdate,
    isCartUpdate,

    makeTip,
    setMakeTip,
    handleCloseTip,

    searchInputTip,
    handleCloseSearchInputTip,
    setSearchInputTip,
    OEImagesURL,
    OEDetailsImagesURL,
    business_ledger_id,

    setIsFavUpdate,
    isFavUpdate,
    business_delivery_days,

    setPopularModels,
    popular_models,


    handleCancelZIndex,
    setModalZIndex,
    modalZIndex,


    vat_amount,

    setShowLoginPopup,
    showLoginPopup,
    showPopupScreen,
    setShowPopupScreen,
    closePopup,


    HandleLogout,
    removePaymentMethod,
    rewards_points,


    min_purchase_amount
  };




  return (
    <ConfigContext.Provider value={vals}>
      {children}
    </ConfigContext.Provider>
  );
};
